import css from 'styled-jsx/css'
import { colors, fontSizes, measurements, fontWeights } from 'theme'

export const propertyDocInfoStyles = css`
  .base-property-doc-info,
  .base-property-doc-info :global(.wrapper-card) {
    height: 100%;
    margin-bottom: 0;
    justify-content: space-between;
  }
  .base-property-doc-info .header {
    display: flex;
    align-items: center;
  }
  .base-property-doc-info .header .icon {
    max-width: 5rem;
    margin-right: 1.5rem;
  }
  .base-property-doc-info .header .icon img {
    width: 100%;
    border-radius: ${measurements.borderRadius};
  }
  .base-property-doc-info .header .title {
    width: 100%;
    font-weight: ${fontWeights.bold};
    margin: 0 auto;
    font-size: ${fontSizes.h5};
  }
`

export const propertyFooterStyles = css`
  .property-footer {
    display: flex;
  }
  .property-footer p {
    margin: 0;
  }
  .property-footer .footer-icon {
    width: 1.5rem;
    margin-top: 0.2rem;
    margin-right: 1rem;
  }
  .property-footer .footer-icon img {
    width: 100%
  }
  .property-footer .highlight-message {
    color: ${colors.primary};
    font-weight: ${fontWeights.semiBold};
  }
  .property-footer :global(i.check-icon) {
    background-color: ${colors.primary};
    border-radius: 50%;
    color: ${colors.white};
    padding: 0 0.3rem;
  }
`